import { render, staticRenderFns } from "./warningAlert.vue?vue&type=template&id=25c5e764&"
import script from "./warningAlert.vue?vue&type=script&lang=js&"
export * from "./warningAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports